import { NgClass, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { ButtonComponent, ButtonVariant } from '@atoms/button/button.component';
import { LinkButtonComponent } from '@atoms/link-button/link-button.component';

@Component({
  selector: 'iahoy-generic-action-modal',
  imports: [
    ButtonComponent,
    LinkButtonComponent,
    MatDialogActions,
    ReactiveFormsModule,
    NgOptimizedImage,
    NgClass,
    MatDialogTitle,
    MatDialogContent,
    MatDialogClose
  ],
  templateUrl: './generic-action-modal.component.html',
  styleUrl: './generic-action-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GenericActionModalComponent {
  readonly dialogRef = inject(MatDialogRef<GenericActionModalComponent>);
  data = inject(MAT_DIALOG_DATA);
  headerTitle: string;
  messageHtml: string;
  actionLabel?: string;
  cancelLabel?: string;
  messageClass?: string;
  headerIcon?: string;
  disclaimerText?: string;
  buttonType: ButtonVariant = 'default';
  action: () => void;
  loading = false;

  constructor() {
    this.headerTitle = this.data.headerTitle;
    this.messageHtml = this.data.messageHtml;
    this.actionLabel = this.data.actionLabel;
    this.cancelLabel = this.data.cancelLabel;
    this.messageClass = this.data.messageClass;
    this.buttonType = this.data.buttonType ?? this.buttonType;
    this.headerIcon = this.data.headerIcon;
    this.disclaimerText = this.data.disclaimerText;
    this.action = this.data.action;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAction(): void {
    this.loading = true;
    this.action();
  }
}
